// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"becd4f74","804":"1d22a742","1001":"becd4f74","2797":"bc046043","3846":"be85c8ac","4208":"becd4f74","7932":"becd4f74","8072":"ac4ada9a"}[chunkId] + ".chunk.css";
};